import { CampaignStatusSchema } from "@adlywise/shared";
import { toDateInputValue } from "@/utils/dateUtils";

const Status = CampaignStatusSchema.enum;

export const STATUSES = [
  { value: Status.draft, label: "Draft" },
  { value: Status.active, label: "Active" },
  { value: Status.paused, label: "Paused" },
  { value: Status.completed, label: "Completed" },
];

export const DEFAULT_CAMPAIGN = {
  name: "",
  description: "",
  status: Status.draft,
  selectedSegments: [],
  userId: "",
  defaultCreativeId: "",
  startDate: "",
  endDate: "",
  icon: null,
  cpm: 0,
  dailyFrequency: "",
  weeklyFrequency: "",
  impressionsCap: "",
  budgetCap: "",
  impressionDomain: null,
};

export const toFormState = (campaign) => {
  if (!campaign) return { ...DEFAULT_CAMPAIGN };

  return {
    ...DEFAULT_CAMPAIGN,
    ...campaign,
    selectedSegments: Array.isArray(campaign.selectedSegments)
      ? campaign.selectedSegments
          .map(String)
          .filter((id) => id && id !== "undefined" && id !== "null")
      : [],
    defaultCreativeId: campaign.defaultCreativeId ?? "",
    startDate: toDateInputValue(campaign.startDate),
    endDate: toDateInputValue(campaign.endDate),
    cpm: campaign.cpm ?? 0,
    dailyFrequency:
      campaign.dailyFrequency != null ? String(campaign.dailyFrequency) : "",
    weeklyFrequency:
      campaign.weeklyFrequency != null ? String(campaign.weeklyFrequency) : "",
    impressionsCap:
      campaign.impressionsCap != null ? String(campaign.impressionsCap) : "",
    budgetCap: campaign.budgetCap != null ? String(campaign.budgetCap) : "",
    impressionDomain: campaign.impressionDomain ?? null,
  };
};

export const toNullableInt = (v) => {
  if (v === "" || v === null || v === undefined) return null;
  const n = parseInt(v, 10);
  return Number.isFinite(n) ? n : null;
};

export const toNullableFloat = (v) => {
  if (v === "" || v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};
